module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1BcJbFE/tc-custom/9781459293014.jpg?1705003723443",
      "alt": "This image is the cover for the book Drakon Baby Bargain, The Drakon Royals"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Drakon Baby Bargain, The Drakon Royals\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_c('b', [_vm._v("A deal sealed with passion!")])]), _c('i', [_c('b')]), _c('br'), _c('br'), _vm._v("Illegitimate and overlooked, Eleni, Princess of Drakon, yearns for a family. At a masquerade ball, one stolen kiss with a stranger sparks an opportunity! Gabriel Marquez wants her to care for his childcould this be Eleni's chance to strike a deal of her own? "), _c('br'), _c('br'), _vm._v("Gabriel, Drakon's biggest investor, is shocked by Eleni's bold bargainingbut a convenient marriage would be advantageous to them both! He'll gain a stand-in mother for his daughter, and Eleni the baby she longs for. Except Gabriel hasn't predicted the fire raging between themone which will bind them together forever!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tara Pammi\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Tara Pammi can't remember a moment when she wasn't lost in a book, especially a romance which, as a teenager, was much more exciting than mathematics textbook. Years later Tara’s wild imagination and love for the written word revealed what she really wanted to do: write! She lives in Colorado with the most co-operative man on the planet and two daughters. Tara loves to hear from readers and can be reached at tara.pammi@gmail.com or her website www.tarapammi.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0